import { createApp, h } from 'vue'
import App from './App.vue'
import singleSpaVue from 'single-spa-vue'
import router from './router'
import createVuetifyPlugin from './plugins/vuetify.js'
import i18n from './locales/i18n.js'
import { createPinia } from 'pinia'
import pkg from '../package.json'

let singleSpaProps = {}
let cachedMfName = null
let cachedKeyName = null

// Calculate mfName and keyName once when props are available
const getMfConfig = () => {
  if (!cachedMfName) {
    cachedMfName = singleSpaProps.name || pkg.name || 'unknown-microfrontend'
    cachedKeyName = `${cachedMfName}-config`
  }
  return { mfName: cachedMfName, keyName: cachedKeyName }
}

const vueLifecycles = singleSpaVue({
  createApp,
  appOptions: {
    render() {
      const { keyName } = getMfConfig()

      return h(App, {
        singleSpaProps,
        mfConfig: singleSpaProps[keyName] || singleSpaProps,
        palette: singleSpaProps.palette,
        realm: singleSpaProps.realm,
      })
    }
  },
  handleInstance: (app, props) => {
    singleSpaProps = props

    const { mfName } = getMfConfig()
    console.log(`Mounted ${mfName} v${pkg.version}`)

    // Configure Vuetify with the palette received from props
    const vuetify = createVuetifyPlugin(props.palette || {}, i18n)
    app.use(vuetify)
    app.use(router)
    app.use(i18n)
    app.use(createPinia())
  }
})

export const bootstrap = vueLifecycles.bootstrap
export const mount = vueLifecycles.mount
export const unmount = vueLifecycles.unmount
